import { HttpInterceptorFn, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from '@core/auth/services/auth-service';
import { environment } from '@environments/environment';
import { catchError, throwError } from 'rxjs';

export const requestInterceptor: HttpInterceptorFn = (request: HttpRequest<any>, next) => {
  const authService = inject(AuthService);
  const token = authService.getToken();
  const apiUrl = environment.apiUrl;

  // Ignorar assets locales
  if (request.url.startsWith('assets/')) {
    return next(request);
  }

  let clonedRequest = request.clone({
    url: `${apiUrl}${request.url}`
  });

  if (token) {
    clonedRequest = clonedRequest.clone({
      setHeaders: { Authorization: `Bearer ${token}` }
    });
  }

  return next(clonedRequest).pipe(
    catchError((error: HttpErrorResponse) => {
      // Si la respuesta es 401 (Unauthorized), manejar expiración de sesión
      if (error.status === 401) {
        authService.handleSessionExpired();
      }
      return throwError(() => error);
    })
  );
};